import { render, staticRenderFns } from "./exercised.vue?vue&type=template&id=9f164ce8&"
import script from "./exercised.vue?vue&type=script&lang=js&"
export * from "./exercised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f164ce8')) {
      api.createRecord('9f164ce8', component.options)
    } else {
      api.reload('9f164ce8', component.options)
    }
    module.hot.accept("./exercised.vue?vue&type=template&id=9f164ce8&", function () {
      api.rerender('9f164ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/exercised.vue"
export default component.exports